export default function() {
	(function ($) {

		let firstSlide = $('.hp-intro .swiper-slide').first();
		let firstTitle =  $(firstSlide).find('.hp-intro-title');
		let firstTitleText = $(firstTitle).text();

		gsap.set('.about_headline', {opacity: 0});

		//Set 0 opacity to title before page loaded
		gsap.set('.hp-intro-title', {opacity: 0})

		//Remove class form text and hide it
		let firstText =  $(firstSlide).find('.text');
		$(firstText).removeClass('hp-intro-text-active');


		$(window).load(function () {

			//Show main text wth animation on page load
			setTimeout(function(){
				$(firstText).removeClass('hp-intro-text-hidden');
				$(firstText).addClass('hp-intro-text-active');
			}, 500);

			//Animate title on page load
			//display title
			gsap.to('.hp-intro-title', {opacity: 1, duration: 0});

			//slit words to spans
			let spans = '<span>' + firstTitleText.split(/\s+/).join(' </span><span>') + '</span>';
			//reset min-height
			$(firstTitle).css('min-height',  "unset");
			//Get title height
			let titleHeight = $(firstTitle).height();
			//Set min height so title dont jump when animating
			$(firstTitle).css('min-height', titleHeight + "px");
			//Remove text from title
			$(firstTitle).html('');
			//Animate text in title word by word
			$(spans).hide().appendTo($(firstTitle)).each(function(i) {
				$(this).delay(150 * i).fadeIn();
			});

			if($('.about_headline').length){

				let aboutElement =  $('.about_headline');
				let aboutText = $(aboutElement).text();

				gsap.to('.about_headline', {opacity: 1, duration: 0});

				let aboutSpans = '<span>' + aboutText.split("").join('</span><span>') + '</span>';


				let aboutDiv = '<div>' + aboutSpans + '</div>';
				$(aboutDiv).appendTo($(aboutElement));

				$('.about_headline > div > span').each(function(i) {
					let $this = $(this);
					setTimeout(function() {
						$($this).addClass('active');
					}, 15 * i);
				});


			}

		});


		$( window ).on( 'load orientationchange', function() {
			if (document.querySelector('.hp-intro .swiper-container')) {

				const swiper = document.querySelector('.hp-intro .swiper-container').swiper;

				let activeIndex = swiper.activeIndex;
				let realIndex = swiper.realIndex;
				const element = $(swiper)[0].el;
				const allSlides = $('.hp-intro .swiper-container');
				let timeout = swiper.params.autoplay.delay - 600;
				let titles = [];

				$(allSlides).find('.swiper-slide').each(function () {
					//set data-src for every iframe
					let baseSrc = $(this).find('iframe').attr('src');
					$(this).find('iframe').attr('data-src', baseSrc);

					let $this = $(this);
					setTimeout(function () {
						$($this).find('.hp-intro-text').removeClass('hp-intro-text-active');
					}, timeout);


					let title = $(this).find('.hp-intro-title').text();
					let spans = '<span>' + title.split(/\s+/).join(' </span><span>') + '</span>';
					titles.push(spans);

				});


				swiper.on('slideChange', function () {
					activeIndex = swiper.activeIndex;
					realIndex = swiper.realIndex;

					let currentTitle = $(titles)[activeIndex];

					$(element).find('.swiper-slide').each(function () {

						//Remove src from every iframe in all slides
						let frame = $(this).find('iframe').get(0);
						$(frame).attr('src', '');

						//Pause and reset video in all slides
						let video = $(this).find('video').get(0);
						if (video) {
							video.pause();
							video.currentTime = 0;
						}


						let text = $(this).find('.hp-intro-text');
						setTimeout(function () {
							$(text).removeClass('hp-intro-text-active');
						}, timeout);


					});

					//start iframe or video on actual slide
					let played = $(element).find('.swiper-slide')[realIndex];

					let showTimeout = 0;

					$(currentTitle).each(function () {
						showTimeout++;
					});
					setTimeout(function () {
						$(played).find('.hp-intro-text').addClass('hp-intro-text-active');
					}, 300);
					// }, 200 * showTimeout - 100);

					let $playedText = $(played).find('.hp-intro-text');
					let $playedNav = $(played).find('.hp-intro-navigation span');


					//adds active class to navigation
					$($playedNav).each(function () {
						if ($(this).text() === $($playedText).find('p').text()) {
							$(this).addClass('hp-intro-navigation--active');
						} else {
							$(this).removeClass('hp-intro-navigation--active');
						}
					});


					let framePlayed = $(played).find('iframe').get(0);
					let videoPlayed = $(played).find('video').get(0);
					let videoSRC = $(framePlayed).attr('data-src');
					$(framePlayed).attr('src', videoSRC);

					if (videoPlayed) {
						videoPlayed.play();
					}

				});
			}
		});

		$(window).load(function(){
			let navs = [];
			$('.hp-intro .swiper-container').find('.swiper-slide').each(function (){
				let text = $(this).find('.hp-intro-text p');

				navs.push('<span>' + text.text() + '</span>');
			});
			$('.swiper-slide').each(function() {
				$(this).find('.hp-intro-nav').prepend('<div class="hp-intro-navigation">' + navs.join('') + '</div>');
			});
			//adds active class for first element in navigation
			$('.hp-intro-navigation span').first().addClass('hp-intro-navigation--active');
		});



	})(jQuery);
}